/* Логотип FRAM: слот под logo.png слева от словесного знака (§7 — заказчик добавит файл
 * `public/logo.png`). Пока файла нет — фолбэк на встроенную SVG-марку (две ноги связки:
 * лонг↑ + шорт↓), чтобы шапка не «прыгала» и работала без бинарного ассета. */

import { useState } from 'react'

interface LogoMarkProps {
  size?: number
  className?: string
}

export function LogoMark({ size = 36, className }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="framMark" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B82F6" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#framMark)" />
      <path
        d="M19 42 L29 26 L35 34"
        stroke="#fff"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.95"
      />
      <path
        d="M45 22 L35 38 L29 30"
        stroke="#BFDBFE"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.9"
      />
    </svg>
  )
}

export function Logo() {
  // Слот под logo.png (§7). Если файл есть — показываем его; при ошибке загрузки
  // (файла ещё нет) — фолбэк на SVG-марку.
  const [pngOk, setPngOk] = useState(true)
  return (
    <div className="logo">
      {pngOk ? (
        <img
          src="/logo.png"
          alt="FRAM"
          className="logo__png"
          onError={() => setPngOk(false)}
        />
      ) : (
        <LogoMark className="logo__mark" />
      )}
      <div>
        <div className="logo__word">FRAM</div>
        <div className="logo__sub">Funding Arbitrage</div>
      </div>
    </div>
  )
}
